export default __webpack_public_path__ + "static/tag-dont-3-dark-634c0faa80768337fcba6b17f75f7a7b.png";